module.exports = __webpack_public_path__ + "static/img/hk.ccc5b972.svg";